import React, { Component } from "react";
import { Button, ButtonToolbar, ButtonGroup } from "react-bootstrap";

class ListGroup2 extends Component {
  

 
 
handelSelect=(event)=>{

const btn={title:event.target.value,active:false,isSC:true}
  this.props.onItemSelect(btn)
}



  render() {
    const {
      items,
     

 
      onItemSelect
    } = this.props;

    return (
      <React.Fragment>
        <ButtonToolbar>
          <ButtonGroup>
            {items.map(item => (
              <Button
                onClick={() => onItemSelect(item)}
                key={item['title'] }
                className={
                  item['active']
                    ? "list-group-item active btn-sm"
                    : "list-group-item btn-sm"
                }
              >
                {item['title'] }
              </Button>
            ))}
          </ButtonGroup>
          &nbsp;&nbsp;
        
        </ButtonToolbar>
      </React.Fragment>
    );
  }
}

export default ListGroup2;



// WEBPACK FOOTER //
// ./src/components/common/listGroup2.jsx